import React from 'react';
import ContactForm from './ContactForm.jsx'; // Correct path (same folder)
import SEO from '../components/SEO.jsx';

export default function Contact() {
  return (
    <div className="min-h-screen bg-blue-50 py-20 px-4 text-center">
      <SEO
        title="Contact 2merative Web Design"
        description="Get in touch with 2merative to discuss your website project. We're here to help small businesses in Adelaide and beyond with modern, affordable web design."
        path="/contact"
        image="/og-image.png"
      />

      <h1 className="text-4xl font-bold text-blue-700 mb-6">Contact Us</h1>
      <p className="text-gray-700 mb-8">
        We'd love to hear about your project or idea.
      </p>
      <ContactForm />
    </div>
  );
}
